
import React from "react";
import { Send, BarChart, Package } from "lucide-react";

const iconMap: { [key: string]: JSX.Element } = {
  "Send": <Send size={24} color="#000000" />,
  "BarChart": <BarChart size={24} color="#000000" />,
  "Package": <Package size={24} color="#000000" />
};

interface IconDescriptionProps {
  iconName: string;
}

const IconDescriptionComponent: React.FC<IconDescriptionProps> = ({ iconName }) => {
  return iconMap[iconName] || <Send size={24} color="#000000" />; 
};

export default IconDescriptionComponent;
